<template>
  <base-status-layout
    :operators="operators"
    :in-progress-cards="inProgressCards"
    :ready-to-handout-cards="readyToHandoutCards"
    :carousel-images="mediaStore.selectedImages"
    :formatted-avg-collection-time="formattedAvgCollectionTime"
  />
</template>

<script>
import BaseStatusLayout from "@/core/components/layout/BaseStatusLayout"
import { mapActions, mapState } from "pinia"
import { useOperatorStore } from "@/store/operator"
import { useSettingStore } from "@/store/settings"
import { useMediaStore } from "@/store/media"

export default {
  name: "Status",
  components: { BaseStatusLayout },
  data() {
    return {
      operatorsNum: null,
      operators: null,
      avgCollectionTime: 60,
    }
  },
  computed: {
    ...mapState(useOperatorStore, ["prescriptionCards"]),
    ...mapState(useSettingStore, ["settingsList"]),
    mediaStore() {
      return useMediaStore()
    },
    inProgressCards() {
      return this.prescriptionCards.filter((c) =>
        [0, "0", 1, "1"].includes(c.current_status)
      )
    },
    readyToHandoutCards() {
      return this.prescriptionCards.filter((c) =>
        [2, "2"].includes(c.current_status)
      )
    },
    formattedAvgCollectionTime() {
      return Math.ceil(this.avgCollectionTime / 60)
    }
  },
  methods: {
    ...mapActions(useOperatorStore, ["getPrescriptions"]),
    ...mapActions(useSettingStore, ["getSettingsList"]),
    async handleStatusUpdate({ uuid, current_status }) {
      await this.getPrescriptions()
      const updateCard = this.prescriptionCards.find((card) => card.uuid === uuid)
      if (updateCard) {
        this.$set(updateCard, "current_status", current_status)
      }
    },
    handleAvgCollectionTime(data) {
      if (data && data.average_collection_time > 0) {
        this.avgCollectionTime = data.average_collection_time
      }
    },
    async fetchSelectedImages() {
      await this.mediaStore.fetchSelectedImages()
    }
  },
  async mounted() {
    await this.getPrescriptions()
    await this.getSettingsList()
    await this.fetchSelectedImages()

    this.operatorsNum = this.settingsList.number_of_operators
    this.operators = this.operatorsNum > 0

    this.$ws.connect()
    this.$ws.listen("UPDATE_MEDIA_SETTINGS", async () => {
      await this.fetchSelectedImages()
    })
    this.$ws.listen("AVG_COLLECTION_TIME", this.handleAvgCollectionTime)
    this.$ws.listen("STATUS_CHANGE", this.handleStatusUpdate)
    this.$ws.listen("SEND_CARD_TO_OPERATORS", this.handleStatusUpdate)
    this.$ws.listen("CHANGE_NUMBER_OF_OPERATORS", (data) => {
      this.operatorsNum = data.number_of_operators
      this.operators = this.operatorsNum > 0
    })
  },
  destroyed() {
    this.$ws.remove("UPDATE_MEDIA_SETTINGS")
    this.$ws.remove("AVG_COLLECTION_TIME")
    this.$ws.remove("STATUS_CHANGE")
    this.$ws.remove("CHANGE_NUMBER_OF_OPERATORS")
    this.$ws.remove("SEND_CARD_TO_OPERATORS")
  }
}
</script>

<style scoped lang="scss">
.page-container {
  cursor: none !important;
}

</style>
